import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export class WriterTicketsRoutes {
  index() {
    return Ziggy
      .route('writer.support.tickets.index')
      .toString()
  }

  store() {
    return Ziggy
      .route('writer.support.tickets.store')
      .toString()
  }

  show(ticket: number) {
    return Ziggy
      .route('writer.support.tickets.show', ticket)
      .toString()
  }

  newAnswer(ticket: number) {
    return Ziggy
      .route('writer.support.new_answer', ticket)
      .toString()
  }

  closeTicket(ticket: number) {
    return Ziggy
      .route('writer.support.close_ticket', ticket)
      .toString()
  }

  openTicket(ticket: number) {
    return Ziggy
      .route('writer.support.open_ticket', ticket)
      .toString()
  }

}
